import { useEffect, useState } from "react";
import { useAppStore } from "../store/useAppStore";
import { eventsService } from "../services/eventsService";
import { useTranslation } from "react-i18next";

/** True when the selected event has visitor stub mode enabled. */
export function useEventStubMode(): boolean {
  const { selectedEventId } = useAppStore();
  const { i18n } = useTranslation();
  const [stubMode, setStubMode] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!selectedEventId) {
      setStubMode(false);
      return;
    }
    (async () => {
      try {
        const event = await eventsService.getById(selectedEventId);
        if (!cancelled) setStubMode(Boolean(event?.stubMode));
      } catch {
        if (!cancelled) setStubMode(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [selectedEventId, i18n.language]);

  return stubMode;
}

/** Paths still reachable while stub mode is on. */
export function isStubAllowedPath(pathname: string): boolean {
  if (pathname === "/home" || pathname === "/" || pathname === "/onboarding") return true;
  if (pathname === "/login") return true;
  if (pathname === "/start") return true;
  if (pathname.startsWith("/go")) return true;
  if (pathname === "/my" || pathname.startsWith("/my/")) return true;
  if (pathname === "/support" || pathname.startsWith("/support/")) return true;
  return false;
}
